import {createSlice} from '@reduxjs/toolkit'
import {RootState} from '../store/Store'
import { IReportMetadataDto } from './ReportMetadata.model'
import { reportMetadataApi } from './ReportMetadata.api'
import { useDebounce } from '../../../_metronic/helpers'

type InitialState = {
  reportMetadatas: {
    error: string | undefined
    loading: boolean
    data: IReportMetadataDto[]
  }
  reportMetadata: {
    error?: string
    loading: boolean
    data?: IReportMetadataDto
  }
}
const initialState = {
  reportMetadatas: {
    error: undefined,
    loading: false,
    data: [],
  },
  reportMetadata: {
    error: undefined,
    loading: false,
    data: undefined
  }
} as InitialState

export const reportMetadataSlice = createSlice({
  name: 'reportMetadata',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      // Search 
      .addMatcher(reportMetadataApi.endpoints.reportMetadataSearch.matchPending, (state) => {
        state.reportMetadatas = {
          ...initialState.reportMetadatas,
          error: undefined,
          loading: true,
        }
      })
      .addMatcher(
        reportMetadataApi.endpoints.reportMetadataSearch.matchFulfilled,
        (state, action) => {
          state.reportMetadatas = {
            error: undefined,
            loading: false,
            data: action.payload.data,
          }
        }
      )
      .addMatcher(
        reportMetadataApi.endpoints.reportMetadataSearch.matchRejected,
        (state, action) => {
          state.reportMetadatas = {
            ...initialState.reportMetadatas,
            error: action.error.message,
            loading: false,
          }
        }
      )
      // GetByArea
      .addMatcher(reportMetadataApi.endpoints.reportMetadataGetByArea.matchPending, (state) => {
        state.reportMetadata = {
          ...initialState.reportMetadata,
          error: undefined,
          loading: true,
        }
      })
      .addMatcher(
        reportMetadataApi.endpoints.reportMetadataGetByArea.matchFulfilled,
        (state, action) => {
          state.reportMetadata = {
            error: undefined,
            loading: false,
            data: action.payload.data,
          }
        }
      )
      .addMatcher(
        reportMetadataApi.endpoints.reportMetadataGetByArea.matchRejected,
        (state, action) => {
          state.reportMetadata = {
            ...initialState.reportMetadata,
            error: action.error.message,
            loading: false,
          }
        }
      )
  },
})

export const {} = reportMetadataSlice.actions
export default reportMetadataSlice.reducer
export const selectReportMetadatas = (state: RootState) => state.reportMetadataReducer.reportMetadatas.data
export const selectReportMetadatasLoading = (state: RootState) => state.reportMetadataReducer.reportMetadatas.loading
export const selectReportMetadataLoading = (state: RootState) => state.reportMetadataReducer.reportMetadata.loading
